import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface PaymentConfigDto {
  stripePublishableKey: string | null;
  stripeSecretKeyLast4: string | null;
  stripeSecretKeyConfigured: boolean;
  stripeWebhookConfigured: boolean;
  webhookUrl: string;
  encryptionReady: boolean;
  paypalClientId: string | null;
  paypalSecretConfigured: boolean;
  paypalSecretLast4: string | null;
  paypalWebhookId: string | null;
  paypalEnv: string;
  paypalWebhookUrl: string;
}

export interface UpdatePaymentConfigInput {
  stripePublishableKey?: string;
  stripeSecretKey?: string;
  stripeWebhookSecret?: string;
  paypalClientId?: string;
  paypalSecret?: string;
  paypalWebhookId?: string;
  paypalEnv?: 'sandbox' | 'live';
}

const QK = ['payment-config'] as const;

export function usePaymentConfig() {
  return useQuery({
    queryKey: QK,
    queryFn: async () => {
      const res = await apiClient.get<PaymentConfigDto>('/tenant/payment-config');
      return res.data;
    },
  });
}

export function useUpdatePaymentConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdatePaymentConfigInput) => {
      const res = await apiClient.patch<PaymentConfigDto>('/tenant/payment-config', input);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
